import { TextInput } from 'grommet';
import styled from 'styled-components';
import { focus, gray6 } from '../globals/colors';

export const Input = styled(TextInput)`
    background: white;
    color: #000;
    height: 2.1em;
    padding: 0 .5em;
    font-weight: 500;
    border: solid 2px transparent;

    ::placeholder {
        color: ${gray6};
        font-weight: lighter;
    }

    &:focus{
        box-shadow: 0 0 0 2px ${focus};
    }
`;
